import type { paths } from "./schema.ts";
import { CONFIG } from "@/lib/config.ts";
import type { SearchParamsOption } from "ky";

export type ApiEndpoint = keyof paths;

const { API_URL } = CONFIG;

export function getApiUrl(endpoint: ApiEndpoint, params: Record<string, string | number> = {}): string {
  for (const param of Object.keys(params)) {
    endpoint = endpoint.replace(`{${param}}`, `${params[param]}`) as ApiEndpoint;
  }
  return API_URL + endpoint;
}

export function sanitizeSearchParams(
  params?: Record<string, string | number | boolean | string[] | undefined>,
  defaultValues?: Record<string, string | number | boolean>,
): SearchParamsOption {
  const sanitized: SearchParamsOption = {};

  for (const key in params) {
    const value = params[key];

    if (value === undefined || value === "" || (Array.isArray(value) && !value.length)) {
      const defaultValue = defaultValues?.[key];
      if (defaultValue !== undefined) sanitized[key] = defaultValue;
      continue;
    }

    if (Array.isArray(value)) {
      sanitized[key] = value.toString();
      continue;
    }

    sanitized[key] = value;
  }

  return sanitized;
}
